module.exports = __webpack_public_path__ + "img/Logo.7e416fc5.png";